module.exports = __webpack_public_path__ + "static/media/admin-signin-left-shape.ca306001.png";